import Swal from "sweetalert2";

// "admin_viewer" is a read-only clone of "admin": it must see everything an
// admin sees, but it may never create, edit or delete anything.
export const VIEWER_USER_TYPE = "admin_viewer";

// Every role check in the app compares against the plain type strings
// ("admin", "hr", "accounts", ...). Instead of touching all of them, the user
// type that reaches the pages is rewritten to this value for a viewer, so the
// viewer renders exactly the same screens as an admin.
export const VIEWER_VIEWS_AS = "admin";

const STORAGE_KEY = "user_type";

export const getUserType = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch (e) {
    return "";
  }
};
export const setUserType = (userType) => {
  try {
    if (userType) {
      localStorage.setItem(STORAGE_KEY, userType);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    // storage unavailable (private mode) - fall back to "not a viewer"
  }
};

export const isViewer = () => getUserType() === VIEWER_USER_TYPE;

export const canWrite = () => !isViewer();

// The user type as the pages should see it: a viewer browses as an admin.
export const visibleUserType = (userType) =>
  userType === VIEWER_USER_TYPE ? VIEWER_VIEWS_AS : userType;

// Create/edit screens are recognised by their path, e.g. "/createdesignation",
// "/edit-vendor/:id", "/factory/create", "/asset-create-grn/:id".
const WRITE_SEGMENT = /(^|-)(create|edit|add|new|update|delete|remove)/i;

export const isWriteRoute = (pathname) =>
  String(pathname || "")
    .split(/[?#]/)[0]
    .split("/")
    .filter(Boolean)
    .some((segment) => WRITE_SEGMENT.test(segment));

// POST is used both for saving and for reports/filters/lookups, so the
// read-only POST endpoints are allowlisted. Add new report endpoints here.
const READ_ONLY_POST =
  /(report|filter|search|summary|ledger|trial-balance|excel|export|print|pdf|-load|load-|type-check|staff-detail|^\/login\/?$|^\/logout\/?$|^\/me\/?$)/i;

export const isReadRequest = (method, url) => {
  const verb = String(method || "get").toLowerCase();
  if (verb === "get" || verb === "head" || verb === "options") return true;
  if (verb === "post") return READ_ONLY_POST.test(String(url || ""));
  return false;
};

export const READ_ONLY_MESSAGE =
  "Your account has view only access. You cannot add, edit or delete anything.";

let alertOpen = false;

export const readOnlyAlert = (text) => {
  if (alertOpen) return;
  alertOpen = true;
  Swal.fire({
    icon: "info",
    title: "View only access",
    text: text || READ_ONLY_MESSAGE,
    confirmButtonColor: "#3085d6",
  }).finally(() => {
    alertOpen = false;
  });
};
